import {ModuleProto} from "../module-proto"
import {ModuleType} from "../types"
import {SettingsMenuTopCategory} from "../settings-module"
import {SettingsParentSection} from "../../../app/settings/const"

// const debug = "ViewTimelineModule"
const debug = false

export class ViewTimelineModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.VIEW_TIMELINE, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                       = "Timeline"
        this.description                = "The Timeline view allows you to display tasks, meetings, and events on a single timeline, providing a clear and organized way to track and manage your schedule with ease."
        this.svgIcon                    = "isvg-view-timeline"
        this.settingsMenuTopCategory    = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel                  = "Views"
        this.settingsUrl                = "settings/view-timeline"
        this.canDisable                 = false
        this._isEnabled                 = true // because this.canDisable false
        this.parentSection              = SettingsParentSection.VIEWS
    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}